define('lq/events/actions/executePlugin',['lq/events/actions/eventAction'],
    function (EventAction) {
        'use strict';

        function ExecutePlugin(eventData, eventArg) {
            EventAction.call(this, eventData, eventArg);
            return this;
        }

        EventAction.extend(ExecutePlugin, EventAction);

        ExecutePlugin.typeName = 'ExecutePlugin';

        ExecutePlugin.prototype.getBatchType = function () {
            if (this.eventData.doNotBatch) {
                return EventAction.DO_NOT_BATCH;
            }
            return EventAction.COMMAND_BATCH;
        };

        ExecutePlugin.prototype.createEventActionRequest = function () {
            var self = this;
            return {
                eventActionType: "ExecutePlugin",
                morphId: self.eventData.command
            };
        };

        ExecutePlugin.prototype.execute = function (continuation, eventActionResponse) {
            continuation();
        };

        return ExecutePlugin;
    }
);
